// @generated by web/tools/codegen — DO NOT EDIT

/**
 * Public-URL slug-segment helpers (routes-SSOT ADR 0142) — the web mirror of the
 * `slug_url` Rust crate, the single cross-Trinity implementation (backend +
 * mobile consume the same code). `PUBLIC_ID_LENGTH` is generated from
 * `manifests/routes.yaml` (`publicIdLength`); compose/extract mirror
 * `slug_url::{compose_segment, parse_segment}` exactly. The
 * `slug_url_contract_parity` lint pins this constant to the Rust const + routes.yaml.
 *
 * URL shape: listings/estates `{slug}-{publicId}`, blog `{slug}`. The publicId is a
 * fixed-length hyphen-free NanoID, so the split is the last PUBLIC_ID_LENGTH chars —
 * never a fragile split-on-last-hyphen (slugs themselves contain hyphens).
 */

/** NanoID length of a `public_id`. Generated from routes.yaml `publicIdLength`. */
export const PUBLIC_ID_LENGTH = 12;

/** The NanoID alphabet (digits 2-9 + lowercase, excluding the ambiguous `0 1 i l o`). */
export const NANOID_ALPHABET = '23456789abcdefghjkmnpqrstuvwxyz';

/** True iff `s` is a syntactically valid `public_id`. */
export function isPublicId(s: string): boolean {
  return s.length === PUBLIC_ID_LENGTH && [...s].every((c) => NANOID_ALPHABET.includes(c));
}

/**
 * Compose a path segment from a slug + public id: `{slug}-{publicId}`, or
 * `{publicId}` when the slug is empty, or `{slug}` when there is no id (blog).
 */
export function composeSegment(slug: string, publicId: string): string {
  if (!publicId) return slug;
  if (!slug) return publicId;
  return `${slug}-${publicId}`;
}

/**
 * Extract the `public_id` from a path segment — the trailing PUBLIC_ID_LENGTH
 * chars (positional, hyphen-free NanoID); the whole segment when it is already a
 * bare id of that length or shorter.
 */
export function extractPublicId(segment: string): string {
  return segment.slice(-PUBLIC_ID_LENGTH);
}
